import React, { useEffect, useMemo, useState } from "react";
import ScrollingText from "../scrolling/ScrollingText";
import { Announcement } from "../../interface/device.details";
import { isAnnouncementActive } from "./announcement.utils";
import mahbLogo from "../../assets/MAHB_LOGO.jpg";

type Props = {
    announcement?: Announcement;
    footerHeight?: number;
};

const AnnouncementRenderer: React.FC<Props> = ({ announcement, footerHeight }) => {
    const [tick, setTick] = useState(0);

    // Re-evaluate every 30s so it turns on/off automatically
    useEffect(() => {
        const id = setInterval(() => setTick((t) => t + 1), 30_000);
        return () => clearInterval(id);
    }, []);

    const activeMessage = useMemo(() => {
        if (!isAnnouncementActive(announcement)) return null;

        const msg = announcement!.messageContent;

        return {
            lines: msg.lines,
            speed: msg.speed ?? 50,
            backgroundColor: msg.backgroundColor,
            textColor: msg.textColor,
            fontFamily: msg.fontFamily,
            fontSize: msg.fontSize,
            noScroll: msg.noScroll ?? false,
        };
    }, [announcement, tick]);

    if (!activeMessage) {
        return (
            <div style={{
                display: "flex",
                alignItems: "stretch",
                height: footerHeight ?? 50,
                backgroundColor: "#ffffff",
                overflow: "hidden",
            }}>
                <div style={{ flex: 1 }} />
                <img
                    src={mahbLogo}
                    alt="MAHB Logo"
                    style={{
                        height: "100%",
                        width: "auto",
                        objectFit: "contain",
                        padding: "0 12px",
                        display: "block",
                    }}
                />
            </div>
        );
    }

    return (
        <div style={{
            display: "flex",
            alignItems: "stretch",
            height: footerHeight ?? 50,
            overflow: "hidden",
        }}>
            {/* Scrolling text — takes all remaining width */}
            <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
                <ScrollingText
                    sentences={activeMessage.lines}
                    speed={activeMessage.speed}
                    separator=" • "
                    backgroundColor={activeMessage.backgroundColor}
                    textColor={activeMessage.textColor}
                    fontFamily={activeMessage.fontFamily}
                    fontSize={activeMessage.fontSize}
                    noScroll={activeMessage.noScroll}
                />
            </div>

            {/* MAHB logo */}
            <div style={{
                display: "flex",
                alignItems: "center",
                flexShrink: 0,
                backgroundColor: "#ffffff",
                overflow: "hidden",
            }}>
                <img
                    src={mahbLogo}
                    alt="MAHB Logo"
                    style={{
                        height: "100%",
                        width: "auto",
                        objectFit: "contain",
                        padding: "0 12px",
                        display: "block",
                    }}
                />
            </div>
        </div>
    );
};

export default AnnouncementRenderer;
